import "bootstrap/dist/css/bootstrap.min.css";
import Weather from "./Weather";
import './App.css';

function App() {
  return (
    <div className="App">
<Weather defaultCity="Eugene"/>
<div>
     <p className="github">
        <a href="https://github.com/ToniDodd/react-app">Open-source code </a>
      
        {""}  by Toni Dodd
     </p></div>


        
        
      
    </div>
  );
}

export default App;
